import script from "./WorkOrderRead.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkOrderRead.vue?vue&type=script&setup=true&lang=js"

import "./WorkOrderRead.vue?vue&type=style&index=0&id=1fc68f92&lang=css"

const __exports__ = script;

export default __exports__